import React, { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext();

export function CompareProvider({ children }) {
  const [items, setItems] = useState([]);

  const addToCompare = useCallback((product) => {
    setItems(prev => {
      if (prev.length >= 3) return prev;
      if (prev.find(p => p.slug === product.slug)) return prev;
      return [...prev, product];
    });
  }, []);

  const removeFromCompare = useCallback((slug) => {
    setItems(prev => prev.filter(p => p.slug !== slug));
  }, []);

  const isInCompare = useCallback((slug) => {
    return items.some(p => p.slug === slug);
  }, [items]);

  const clearCompare = useCallback(() => setItems([]), []);

  return (
    <CompareContext.Provider value={{ items, addToCompare, removeFromCompare, isInCompare, clearCompare }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  return useContext(CompareContext);
}
